let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("d4idW")).then(() => parcelRequire('3arua'));